import { useEffect } from "react";

// Deep-Link-Ziel zwischen Bereichen: die globale Suche schreibt {type,id}, das
// Zielmodul liest es beim Laden aus und öffnet/scrollt zum Element. Nutzt denselben
// localStorage-Schlüssel wie das bestehende Aufgaben-Verlinkungsmuster.
const KEY = "task_link_target";
const EVENT = "sonne:deeplink";

export function setDeepLinkTarget(type: string, id: string | number) {
  try { localStorage.setItem(KEY, JSON.stringify({ type, id: String(id) })); } catch { /* ignore */ }
  try { window.dispatchEvent(new CustomEvent(EVENT)); } catch { /* ignore */ }
}

// Ruft onTarget mit der Ziel-ID auf, sobald `ready` (Liste geladen) und ein
// passendes Ziel vorliegt; entfernt danach den Schlüssel (einmalig). Reagiert
// sowohl beim Mounten (frischer Tab) als auch auf das Event (gleicher Tab).
export function useDeepLinkTarget(type: string, ready: boolean, onTarget: (id: string) => void) {
  useEffect(() => {
    const tryOpen = () => {
      if (!ready) return;
      let raw: string | null = null;
      try { raw = localStorage.getItem(KEY); } catch { return; }
      if (!raw) return;
      try {
        const parsed = JSON.parse(raw);
        if (parsed?.type === type && parsed?.id != null) {
          onTarget(String(parsed.id));
          try { localStorage.removeItem(KEY); } catch { /* ignore */ }
        }
      } catch { /* ignore */ }
    };
    tryOpen();
    window.addEventListener(EVENT, tryOpen);
    return () => window.removeEventListener(EVENT, tryOpen);
  }, [type, ready, onTarget]);
}
